import React from 'react';
import { ThumbsUpIcon, MessageCircleIcon, Share2Icon, GlobeIcon, MoreHorizontalIcon } from 'lucide-react';
const testimonials = [{
  name: 'Jennifer K.',
  details: 'Holistic Health Enthusiast · California',
  quote: "I bought a $90 herbal medicine book last year and it's collecting dust because I can never find what I'm looking for. The Home Healing Handbook is organized completely differently — I look up the symptom and boom, the answer is right there. For $27 this is honestly embarrassing how good it is. 🙌",
  likes: 189,
  comments: 24,
  shares: 31,
  timeAgo: '5d',
  avatarColor: 'bg-violet-400'
}, {
  name: 'Amanda R.',
  details: 'Wellness Coach · Florida',
  quote: "I was skeptical. I've tried so many of these 'natural remedy' guides and they're always vague and incomplete. This one is different. Real dosages. Real prep instructions. Real substitutes when I can't find an herb. My medicine cabinet now has a plant-based section and I actually use it. 💚",
  likes: 312,
  comments: 45,
  shares: 19,
  timeAgo: '1w',
  avatarColor: 'bg-emerald-400'
}];
export function Testimonials() {
  return <section className="py-8 md:py-14 bg-[#f0f2f5]" data-id="element-285">
      <div className="max-w-2xl mx-auto px-4" data-id="element-286">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-5 md:mb-8" data-id="element-287">
          WHAT OUR READERS ARE SAYING
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-288">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-289">
              {/* Post Header */}
              <div className="flex items-start justify-between p-4 pb-0" data-id="element-290">
                <div className="flex items-center gap-3" data-id="element-291">
                  <div className={`w-10 h-10 ${testimonial.avatarColor} rounded-full flex items-center justify-center shadow-sm`} data-id="element-292">
                    <span className="text-white font-bold text-sm" data-id="element-293">
                      {testimonial.name.split(' ').map(n => n.charAt(0)).join('')}
                    </span>
                  </div>
                  <div data-id="element-294">
                    <p className="font-semibold text-[#050505] text-[15px] leading-tight" data-id="element-295">
                      {testimonial.name}
                    </p>
                    <div className="flex items-center gap-1 text-[#65676b] text-xs" data-id="element-296">
                      <span data-id="element-297">{testimonial.timeAgo}</span>
                      <span data-id="element-298">·</span>
                      <GlobeIcon className="w-3 h-3" data-id="element-299" />
                    </div>
                  </div>
                </div>
                <button className="text-[#65676b] hover:bg-gray-100 rounded-full p-1.5 transition-colors" data-id="element-300">
                  <MoreHorizontalIcon className="w-5 h-5" data-id="element-301" />
                </button>
              </div>

              {/* Post Content */}
              <div className="px-4 py-3" data-id="element-302">
                <p className="text-[#050505] text-[15px] leading-relaxed" data-id="element-303">
                  {testimonial.quote}
                </p>
              </div>

              {/* Reactions Summary */}
              <div className="px-4 pb-2 flex items-center justify-between text-[#65676b] text-[13px]" data-id="element-304">
                <div className="flex items-center gap-1.5" data-id="element-305">
                  <div className="flex -space-x-1" data-id="element-306">
                    <span className="w-[18px] h-[18px] bg-blue-500 rounded-full flex items-center justify-center text-white text-[10px] border border-white z-10" data-id="element-307">
                      👍
                    </span>
                    <span className="w-[18px] h-[18px] bg-red-500 rounded-full flex items-center justify-center text-white text-[10px] border border-white" data-id="element-308">
                      ❤️
                    </span>
                  </div>
                  <span data-id="element-309">{testimonial.likes}</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-310">
                  <span data-id="element-311">{testimonial.comments} comments</span>
                  <span data-id="element-312">{testimonial.shares} shares</span>
                </div>
              </div>

              {/* Divider */}
              <div className="mx-4 border-t border-gray-200" data-id="element-313"></div>

              {/* Action Buttons */}
              <div className="flex items-center justify-around px-2 py-1" data-id="element-314">
                <button className="flex-1 flex items-center justify-center gap-2 py-2 rounded-md hover:bg-gray-100 transition-colors text-[#65676b] font-semibold text-sm" data-id="element-315">
                  <ThumbsUpIcon className="w-5 h-5" data-id="element-316" />
                  <span data-id="element-317">Like</span>
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-2 rounded-md hover:bg-gray-100 transition-colors text-[#65676b] font-semibold text-sm" data-id="element-318">
                  <MessageCircleIcon className="w-5 h-5" data-id="element-319" />
                  <span data-id="element-320">Comment</span>
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-2 rounded-md hover:bg-gray-100 transition-colors text-[#65676b] font-semibold text-sm" data-id="element-321">
                  <Share2Icon className="w-5 h-5" data-id="element-322" />
                  <span data-id="element-323">Share</span>
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}